import React from 'react';
import { FUNNEL_STATUS_LABELS, FUNNEL_STATUS_COLORS } from '../../utils/funnelStatusLabels';

const PipelineProgressSection = ({ funnelStatus, prospectEvaluation, evaluationMessage }) => {
    const pipelineStages = [
        { id: 'prospect', label: FUNNEL_STATUS_LABELS.prospect, check: null },
        { id: 'crawled', label: FUNNEL_STATUS_LABELS.crawled, check: 'crawl_successful' },
        { id: 'contact_extracted', label: FUNNEL_STATUS_LABELS.contact_extracted, check: 'has_good_contact' },
        { id: 'captured', label: FUNNEL_STATUS_LABELS.captured, check: 'capture_successful' },
        { id: 'analyzed', label: FUNNEL_STATUS_LABELS.analyzed, check: 'analysis_complete' },
        { id: 'ready_for_outreach', label: FUNNEL_STATUS_LABELS.ready_for_outreach, check: null },
    ];

    const getStageStatus = (stageId, check) => {
        if (funnelStatus === stageId) {
            return 'current';
        }
        if (check && prospectEvaluation?.checks?.[check]?.passed) {
            return 'completed';
        }
        return 'pending';
    };

    return (
        <div style={{
            marginBottom: '30px',
            background: '#1E293B',
            borderRadius: '12px',
            padding: '20px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        }}>
            <h4 style={{
                marginBottom: '20px',
                color: '#E2E8F0',
                fontWeight: '700',
                fontSize: '1.25rem',
                borderBottom: '1px solid #334155',
                paddingBottom: '15px',
            }}>
                Prospect Pipeline Progress
            </h4>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative',
                padding: '0 10px',
            }}>
                {/* Line connecting stages */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '0',
                    right: '0',
                    height: '2px',
                    background: '#334155',
                    transform: 'translateY(-50%)',
                    zIndex: 0,
                }} />

                {pipelineStages.map((stage, index) => {
                    const status = getStageStatus(stage.id, stage.check);
                    const isCurrent = status === 'current';
                    const isCompleted = status === 'completed';
                    const isPending = status === 'pending';

                    const color = isCompleted ? FUNNEL_STATUS_COLORS[stage.id] || '#10B981' : isCurrent ? FUNNEL_STATUS_COLORS[stage.id] || '#3B82F6' : '#64748B';
                    const backgroundColor = isCompleted ? color : isCurrent ? color : '#475569';

                    return (
                        <div 
                            key={stage.id} 
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                zIndex: 1,
                                flex: 1,
                                position: 'relative',
                            }}
                        >
                            <div style={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                backgroundColor: backgroundColor,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                color: '#FFFFFF',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                border: `2px solid ${isCurrent ? '#E2E8F0' : 'transparent'}`,
                                boxShadow: isCurrent ? '0 0 0 4px #93C5FD' : 'none',
                                transition: 'all 0.3s ease',
                            }}>
                                {isCompleted ? '✓' : index + 1}
                            </div>
                            <div style={{
                                marginTop: '10px',
                                fontSize: '12px',
                                fontWeight: isCurrent || isCompleted ? '600' : '400',
                                color: isCurrent || isCompleted ? '#E2E8F0' : '#94A3B8',
                                textAlign: 'center',
                                transition: 'color 0.3s ease',
                            }}>
                                {stage.label}
                            </div>
                        </div>
                    );
                })}
            </div>
            {evaluationMessage && (
                <div style={{
                    marginTop: '16px',
                    padding: '12px 16px',
                    backgroundColor: 'rgba(239, 68, 68, 0.1)',
                    border: '1px solid rgba(239, 68, 68, 0.35)',
                    borderRadius: '8px',
                    color: '#fca5a5',
                    fontSize: '13px',
                    lineHeight: 1.5,
                }}>
                    <strong style={{ color: '#f87171' }}>Evaluation failed:</strong>{' '}
                    {evaluationMessage}
                </div>
            )}
        </div>
    );
};

export default PipelineProgressSection;
